

import { Component, inject, signal, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'; // Importar desde @angular/forms
import { AuthService } from '../user-panel/auth.service';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent {
  private fb = inject(FormBuilder); // Forma recomendada en Angular 17
  private baseUrl = environment.apiUrl;

  constructor(private authService:AuthService, private http: HttpClient, private router: Router) {}

  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(12)]]
  });

  submitted = signal(false); 

  get f() {
    return this.loginForm.controls;
  }

  ngOnInit(): void {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      this.router.navigate(['/']);
    }
  }

  onSubmit() {
    this.submitted.set(true); 

    if (this.loginForm.invalid) {
      return;
    }else{
      return this.http.post(`${this.baseUrl}/api/Auth/login`,{  
        email: this.loginForm.value.email,
        password: this.loginForm.value.password})
      .subscribe((response: any) => {
          this.authService.login(response.token)
      });
    }
  }
}
